import React from "react";
import { connect } from "react-redux";
import DenunciasGrid from "./denuncias";
import FormDenunicas from "./NuevaDenuncia/view";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { setTipoDenuncia, callListMyData, getCompanyDetailData, getValidOffices } from "./actions";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

class Denuncias extends React.Component {
  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  componentDidMount = () => {
    if (!this.props.dataCompany || this.props.dataCompany.RutEmpresa !== this.props.companyId) {
      this.props.dispatch(getCompanyDetailData(this.props.companyId));
      this.props.dispatch(getValidOffices(this.props.companyId));
    }
    if (this.props.listaSexos.length === 0 || this.props.listaNacionalidades.length === 0 || this.props.listaPueblosOriginarios.length === 0 ||
      this.props.listaCategoriasOcupacionales.length === 0 || this.props.listaTiposIngreso.length === 0 || this.props.listaTiposContrato.length === 0 ||
      this.props.listaTiposCalle.length === 0 || this.props.listaClasificacionesAccidentes.length === 0 || this.props.listaMediosPrueba.length === 0 ||
      this.props.listaTipoDenuncias.length === 0 || this.props.listaProfesiones.length === 0 ||
      this.props.listaTipoEmpresa.length === 0 || this.props.listaActividadEconomica.length === 0 ||
      this.props.listaPropiedadEmpresa.length === 0 || this.props.listaDirecciones.length === 0 ||
      this.props.listaTiposAccidenteTrayecto.length === 0 || this.props.listaTiposAccidente.length === 0) {
      const lista = {
        listaSexos: this.props.listaSexos.length === 0,
        listaNacionalidades: this.props.listaNacionalidades.length === 0,
        listaPueblosOriginarios: this.props.listaPueblosOriginarios.length === 0,
        listaCategoriasOcupacionales: this.props.listaCategoriasOcupacionales.length === 0,
        listaTiposIngreso: this.props.listaTiposIngreso.length === 0,
        listaTiposContrato: this.props.listaTiposContrato.length === 0,
        listaTiposCalle: this.props.listaTiposCalle.length === 0,
        listaClasificacionesAccidentes: this.props.listaClasificacionesAccidentes.length === 0,
        listaMediosPrueba: this.props.listaMediosPrueba.length === 0,
        listaTipoDenuncias: this.props.listaTipoDenuncias.length === 0,
        listaProfesiones: this.props.listaProfesiones.length === 0,
        listaTipoEmpresa: this.props.listaTipoEmpresa.length === 0,
        listaActividadEconomica: this.props.listaActividadEconomica.length === 0,
        listaPropiedadEmpresa: this.props.listaPropiedadEmpresa.length === 0,
        listaDirecciones: this.props.listaDirecciones.length === 0,
        listaTipoAccidenteTrayecto: this.props.listaTiposAccidenteTrayecto.length === 0,
        listaTipoAccidente: this.props.listaTiposAccidente.length === 0,
      };
      this.props.dispatch(callListMyData("", lista));
    }
  }

  shouldComponentUpdate = (nextProps) => {
    if (nextProps.isLoading !== this.props.isLoading || nextProps.showForm !== this.props.showForm) {
      return true;
    }
    return false;
  }

  handleSelectTipo = (tipo) => {
    this.props.dispatch(setTipoDenuncia(tipo));
  }

  render() {
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <DenunciasGrid />
        <FormDenunicas />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.denuncias.isLoading,
  showForm: state.denuncias.showHideForm,
  dataCompany: state.denuncias.dataCompany,
  companyId: state.global.companyId,
  selectedTipoDenuncia: state.denuncias.selectedTipoDenuncia,
  listaSexos: state.global.listaSexos,
  listaNacionalidades: state.global.listaNacionalidades,
  listaPueblosOriginarios: state.global.listaPueblosOriginarios,
  listaCategoriasOcupacionales: state.global.listaCategoriasOcupacionales,
  listaTiposIngreso: state.global.listaTiposIngreso,
  listaTiposContrato: state.global.listaTiposContrato,
  listaTiposCalle: state.global.listaTiposCalle,
  listaClasificacionesAccidentes: state.global.listaClasificacionesAccidentes,
  listaMediosPrueba: state.global.listaMediosPrueba,
  listaTipoDenuncias: state.global.listaTipoDenuncias,
  listaProfesiones: state.global.listaProfesiones,
  listaTipoEmpresa: state.global.listaTipoEmpresa,
  listaActividadEconomica: state.global.listaActividadEconomica,
  listaPropiedadEmpresa: state.global.listaPropiedadEmpresa,
  listaDirecciones: state.global.listaDirecciones,
  listaTiposAccidente: state.global.listaTiposAccidente,
  listaTiposAccidenteTrayecto: state.global.listaTiposAccidenteTrayecto,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Denuncias);
